<template>
  <!-- 计算文本字段 -->
  <jw-input v-if="modulesItem?.setting?.fieldType === 24" v-model="modulesItem.fieldValue" :placeholder="quoteFieldPlaceholder" disabled class="system-form-item-fields computed-fields ly-form-item-fields-disabled" />

  <jw-input v-else v-qfeiTrim :max-length="confine.number5001" v-model="modulesItem.fieldValue" :placeholder="isQuoteField ? quoteFieldPlaceholder : modulesItem.placeholder || t('请输入') + modulesItem?.setting?.fieldName" :disabled="isQuoteField || modulesItem.businessData == '0' || disabledAll" :class="[isTask ? 'task-fields' : 'system-form-item-fields', modulesItem?.setting?.fieldType == 11 && modulesItem?.fieldValue && !tools.checkLink(modulesItem.fieldValue) ? 'link-item-label' : '', isQuoteField ? 'ly-form-item-fields-disabled' : '']" @blur="handleChange" />
</template>

<script setup>
import { confine } from '@/utils/const.js';
import { useI18n } from 'vue-i18n';
import { tools } from '@/utils/tools';
import { ref, inject } from 'vue';
const { t } = useI18n();
const emits = defineEmits(['cb']);
const isQuoteField = inject('fhFormFieldsParams')?.isQuoteField;
const quoteFieldPlaceholder = inject('fhFormFieldsParams')?.quoteFieldPlaceholder;

const props = defineProps({
  modules: {
    type: Object,
    default: () => {}
  },
  isTask: {
    type: Boolean,
    default: false
  },
  disabledAll: {
    type: Boolean,
    default: false
  }
});

const modulesItem = ref(props?.modules);

const handleChange = () => {
  emits('cb', modulesItem.value);
};
</script>

<style scoped lang="less">
@import './text.less';
</style>
